import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import App from "../app";

const appData = window.asos.sv.state;
delete window.asos.sv.state;

const start = async () => {
  loadableReady(() => {
    hydrateRoot(
      document.getElementById("react-root"),
      <App appData={appData} />
    );
  });
};

start();
